import React from 'react'

function TechSelectHightec() {
  return (
    <embed src="\pdfs\E1.3.2_mfu_hightec_1x1-f6_h13_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectHightec